import { useEffect, useMemo } from 'react';

import { ALL_OPTION_KEY } from '@/common/constants';
import { API_URL } from '@/dtos';

import { useGetEmployerIdParam } from '../../hooks';
import { useBaseReportTableQuery } from '../../queries';
import { UndeliverableMailReportTableParams } from '../UndeliverableMailReport.types';

export const QUERY_KEY = 'UNDELIVERABLE_MAIL_REPORT_QUERY';

const MIN_SEARCH_LEN = 3;
const useUndeliverableMailReportQuery = (params: Partial<UndeliverableMailReportTableParams>) => {
  const currentSearch = useMemo(() => {
    if (!!params?.searchString && params?.searchString?.length >= MIN_SEARCH_LEN) {
      return params.searchString;
    }
    return null;
  }, [params.searchString]);
  const getEmployerIdParam = useGetEmployerIdParam();
  const base = useBaseReportTableQuery(
    API_URL.REPORTS_UNDELIVERABLE_ADDRESS_REPORT_BREAKDOWN,
    [
      QUERY_KEY,
      params?.employerId,
      currentSearch,
      params.employmentStatuses?.join(','),
      params.employerIds?.join(','),
    ],
    {
      ...getEmployerIdParam(params.employerId, params.employerIds),
      show_ssn: true,
      isSSNShowed: params.isSSNShowed,
      search_value: currentSearch,
      employment_statuses:
        params.employmentStatuses && !params.employmentStatuses.includes(ALL_OPTION_KEY)
          ? params.employmentStatuses.join(',')
          : undefined,
    },
    {
      isMultipleEmployers: params.isMultipleEmployer,
      isPreviewMode: params.isPreviewMode,
    }
  );
  useEffect(() => {
    base.setPage(0);
    base.setRawContentList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.employmentStatuses, params?.searchString, params.employerId, params.employerIds?.join(',')]);

  return base;
};

export default useUndeliverableMailReportQuery;
